module.exports = __webpack_public_path__ + "static/img/chanta (9).37c68c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (9).jpg
// module id = uWPm
// module chunks = 0